import { ConnectStores } from "lib/core/store"
import Message from "./Message"

const mapStateToProps = (state, ownProps) => {
  const { send_success } = state.messageStore.state
  const { exitModal } = state.navigationStore.action

  return _.assign(
    {},
    {
      onClose: exitModal,
      send_success
    },
    ownProps
  )
}

const stores = [
  { store: "navigation", watch: false },
  { store: "message", watch: ["send_success"] }
]

export default ConnectStores(Message, stores, {}, mapStateToProps)
